import React from "react";
import { useTranslation } from "react-i18next";

const QuestionTap = ({ setTabname, tabname }) => {
  const { t } = useTranslation();
  const active =
    "inline-block py-[8px] px-[16px] border rounded-3xl bg-[#4E535F] text-[#FAFBFC] subtitle_1_400 cursor-pointer";
  const unactive =
    "inline-block py-[8px] px-[16px] border rounded-3xl text-[#4E535F] subtitle_1_400 border-[#4E535F] cursor-pointer";
  const onClickTabName = (e) => {
    setTabname(e.target.innerText);
  };
  return (
    <div className="pt-[20px] ">
      <div className="flex gap-x-[12px]">
        <span
          className={tabname === t('QuestionTap_all', '전체보기') ? active : unactive}
          onClick={onClickTabName}
        >
          {t('QuestionTap_all', '전체보기')}
        </span>
        <span
          className={tabname === t('QuestionTap_diet', '식생활') ? active : unactive}
          onClick={onClickTabName}
        >
          {t('QuestionTap_diet', '식생활')}
        </span>
        <span
          className={tabname === t('QuestionTap_exercise', '운동') ? active : unactive}
          onClick={onClickTabName}
        >
          {t('QuestionTap_exercise', '운동')}
        </span>
      </div>
      <div className="flex gap-x-[12px] pt-[12px]">
        <span
          className={tabname === t('QuestionTap_daily', '일상생활') ? active : unactive}
          onClick={onClickTabName}
        >
          {t('QuestionTap_daily', '일상생활')}
        </span>
        <span
          className={tabname === t('QuestionTap_stoma', '장루') ? active : unactive}
          onClick={onClickTabName}
        >
          {t('QuestionTap_stoma', '장루')}
        </span>
        <span
          className={tabname === t('QuestionTap_symptoms', '증상') ? active : unactive}
          onClick={onClickTabName}
        >
          {t('QuestionTap_symptoms', '증상')}
        </span>
        <span
          className={tabname === t('QuestionTap_benefits', '혜택') ? active : unactive}
          onClick={onClickTabName}
        >
          {t('QuestionTap_benefits', '혜택')}
        </span>
      </div>
    </div>
  );
};

export default QuestionTap;
